import React, { useEffect } from "react";
import "./privacyAndTerms.scss";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import { flower, sun } from "../../source";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <section className="privacyandterms_sec1">
        <CommonBanner title="Privacy Policy" linkText1="Privacy Policy" />
      </section>

      <section className="privacyandterms_sec2 privacy_container">
        <img src={sun} alt="sun" className="sun_img" />
        <img src={flower} alt="flower" className="flower_img" />
        <div className="my_container">
          <div className="content_wrapper">
            <div className="para_wrapper">
              {/* <h2 className="section_heading32">Introduction</h2> */}
              <p className="section_desc22">
                Welcome to <b>Pathways and Perspectives</b> ("we," "our," or
                "us"). Your privacy is important to us, and we are committed to
                protecting any personal information you share with us. This
                Privacy Policy explains how we collect, use, disclose, and
                safeguard your information when you visit our{" "}
                <a href="/" className="Link_terms_privacy">
                  website
                </a>
                .
              </p>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">1. Information We Collect</h2>
              <p className="section_desc22">
                We collect the following types of information:
              </p>
              <p className="section_desc22">
                <b>1.1 Personal Information</b>
              </p>
              <p className="section_desc22">
                When you register, subscribe, or interact with our platform, we
                may collect personal details such as:
              </p>
              <ul className="privacy_terms_ul">
                <li className="privacy_terms_li section_desc22">Name</li>
                <li className="privacy_terms_li section_desc22">
                  Email address
                </li>
                <li className="privacy_terms_li section_desc22">
                  Contact information
                </li>
                <li className="privacy_terms_li section_desc22">
                  Any other information you voluntarily provide
                </li>
              </ul>
            </div>

            <div className="para_wrapper">
              <p className="section_desc22">
                <b>1.2 Non-Personal Information</b>
              </p>
              <p className="section_desc22">
                We may collect data that does not directly identify you, such
                as:
              </p>
              <ul className="privacy_terms_ul">
                <li className="privacy_terms_li section_desc22">
                  Browser type and version
                </li>
                <li className="privacy_terms_li section_desc22">
                  Device type and operating system
                </li>
                <li className="privacy_terms_li section_desc22">IP address</li>
                <li className="privacy_terms_li section_desc22">
                  Pages visited and time spent on our website
                </li>
                <li className="privacy_terms_li section_desc22">
                  Cookies and tracking technologies
                </li>
                <li className="privacy_terms_li section_desc22">
                  <b>Automatically Generated Tracking Data:</b> We may use
                  analytics tools to collect demographic and behavioral data
                  about our users, such as location, device usage, content
                  preferences, and engagement levels. This helps us improve our
                  platform and understand audience trends.
                </li>
              </ul>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">
                2. How We Use Your Information
              </h2>
              <p className="section_desc22">
                We use the information we collect to:
              </p>
              <ul className="privacy_terms_ul">
                <li className="privacy_terms_li section_desc22">
                  Provide, maintain, and improve our platform
                </li>
                <li className="privacy_terms_li section_desc22">
                  Send newsletters, updates, and promotional materials (with
                  your consent)
                </li>
                <li className="privacy_terms_li section_desc22">
                  Personalize your experience on our website
                </li>
                <li className="privacy_terms_li section_desc22">
                  Analyze trends and user behavior to improve our content
                </li>
                <li className="privacy_terms_li section_desc22">
                  Ensure security and prevent fraud
                </li>
                <li className="privacy_terms_li section_desc22">
                  <b>Enhance User Analytics: </b> The automatically generated
                  tracking data allows us to analyze audience demographics and
                  improve our services based on aggregated insights.
                </li>
              </ul>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">
                3. How We Share Your Information
              </h2>
              <p className="section_desc22">
                We do not sell or rent your personal data. However, we may share
                your information with:
              </p>
              <ul className="privacy_terms_ul">
                <li className="privacy_terms_li section_desc22">
                  <b>Service Providers:</b> Third-party vendors who help operate
                  our website, such as hosting providers and analytics services.
                </li>
                <li className="privacy_terms_li section_desc22">
                  <b>Legal Compliance:</b> If required by law, to protect our
                  rights, or to comply with legal proceedings.
                </li>
                <li className="privacy_terms_li section_desc22">
                  <b>Business Transfers:</b> In case of a merger, sale, or
                  transfer of our assets, your data may be part of the
                  transaction.
                </li>
              </ul>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">
                4. Cookies and Tracking Technologies
              </h2>
              <p className="section_desc22">
                We use cookies and similar tracking technologies to enhance your
                browsing experience. This includes tracking demographic and
                behavioral data to better understand our audience. You can
                modify your browser settings to disable cookies, but this may
                affect certain website functionalities.
              </p>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">5. Third-Party Links</h2>
              <p className="section_desc22">
                Our website may contain links to third-party sites. We are not
                responsible for their privacy policies, and we encourage you to
                review their terms before providing any personal information.
              </p>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">6. Data Security</h2>
              <p className="section_desc22">
                We implement appropriate security measures to protect your data.
                However, no online transmission is 100% secure, and we cannot
                guarantee absolute security.
              </p>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">7. Your Rights</h2>
              <p className="section_desc22">
                Depending on your location, you may have the right to:
              </p>

              <ul className="privacy_terms_ul">
                <li className="privacy_terms_li section_desc22">
                  Access, update, or delete your personal information
                </li>
                <li className="privacy_terms_li section_desc22">
                  Opt out of marketing communications
                </li>
                <li className="privacy_terms_li section_desc22">
                  Restrict or object to certain data processing
                </li>
                <li className="privacy_terms_li section_desc22">
                  Request a copy of your data
                </li>
              </ul>
              <p className="section_desc22 mt-4">
                To exercise any of these rights, please contact us at{" "}
                <a
                  href="mailto:help@pathways&perspectives.in"
                  className="Link_terms_privacy"
                >
                  help@pathways&perspectives.in
                </a>
                {/* [Insert Contact Email]. */}
              </p>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">
                8. Changes to This Privacy Policy
              </h2>
              <p className="section_desc22">
                We may update this Privacy Policy from time to time. Any changes
                will be posted on this page with an updated "Last Updated" date.
              </p>
            </div>

            <div className="para_wrapper">
              <h2 className="section_heading32">9. Contact Us</h2>
              <p className="section_desc22">
                If you have any questions or concerns about this Privacy Policy,
                please contact us at:
              </p>
              <p className="section_desc22">
                <a
                  href="mailto:seek@pathwaysperspectives.com"
                  className="Link_terms_privacy"
                >
                  seek@pathwaysperspectives.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
